import { FC } from 'react'
import './step.css'

// UTILITIES
import { flatten } from '@utils/string-helper'

interface Props {
    state?: 'active' | 'inactive' | 'complete'
}

const Step: FC<Props> = ({ state = 'inactive' }) => {
    const className = flatten(state, 'step')

    return <div className={className} />
}

export default Step